<template>
  <div
    class="menu"
    @mouseleave="triggerOn = false"
  >
    <div
      class="trigger"
      @click="triggerOn = true"
    >
      <slot name="icon"></slot>
      <span>{{title}}</span>
      <iconfont
        class="tri"
        :class="{active: triggerOn}"
        name="#iconxialaxiaosanjiao"
        font-size="6px"
        style="margin-left: 8px; color: #9692A9;"
      ></iconfont>
    </div>
    <div
      class="options"
      v-if="options && options.length"
      v-show="triggerOn"
    >
      <div
        class="item"
        v-for="item in options"
        @click="onClickItem(item)"
      >{{item.label}}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    options: {
      type: Array,
      default () {
        return [];
      }
    }
  },
  components: {
    iconfont: () => import('@/platformCode/iconfont')
  },
  data () {
    return {
      triggerOn: false
    }
  },
  watch: {
    triggerOn (val) {
      this.$emit('triggerOn', val);
    }
  },
  methods: {
    onClickItem (item) {
      this.$emit('clickItem', item);
      this.$nextTick(() => {
        this.triggerOn = false;
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.menu {
  position: relative;
  &:hover .options {
    display: inline-block;
  }
}
.trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  & > .tri {
    transition-duration: 0.3s;
  }
  & > .tri.active {
    transform: rotate(-180deg);
  }
}
.options {
  position: absolute;
  top: 100%;
  left: 50%;
  z-index: 1;
  transform: translateX(-50%);
  // display: none;
  background-color: #fff;
  width: 80px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 2px 10px 0px rgba(96, 98, 121, 0.1);
}
.item {
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  cursor: pointer;
  height: 28px;
  font-size: 12px;
  &:hover {
    background: #f5f7fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/generateVoice/menu.vue